import React, { useState } from "react";
import {
  BrowserRouter as Router,
  Routes,
  Route,
  useNavigate,
  Navigate,
} from "react-router-dom";
import "./App.css";
import apiClient from "../api/client";
import AdminPage from "./AdminPage";
import UserCalendarWrapper from "./UserCalendarWrapper";
import PlaylistPage from "./PlaylistPage";
import EventFunnelPage from "./EventFunnelPage";

function HomePage({ onLogin }) {
  const navigate = useNavigate();
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [isSubmitting, setIsSubmitting] = useState(false);

  const handleLogin = async (e) => {
    e.preventDefault();
    if (!username || !password) {
      alert("請輸入帳號與密碼");
      return;
    }

    setIsSubmitting(true);
    try {
      const response = await apiClient.post("/api/manager/login", {
        username,
        password,
      });

      if (response.data.success) {
        // 登入成功，導向管理頁
        onLogin();
        navigate("/admin");
      } else {
        alert("登入失敗：帳號或密碼錯誤");
      }
    } catch (error) {
      console.error("登入時發生錯誤", error);
      alert("無法連線到伺服器，請稍後再試");
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <div className="App">
      <form className="login-box" onSubmit={handleLogin} noValidate>
        <div className="login-brand" aria-hidden="true">
          <svg
            width="26"
            height="26"
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M3 12h3.5l1.8-4.5L12 17l2.2-6.5L15.5 12H21"
              stroke="currentColor"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
          </svg>
        </div>
        <h1>歡迎進入管理者系統</h1>
        <p className="login-subtitle">請輸入帳號密碼以登入管理後台</p>

        <div className="login-field">
          <label htmlFor="username">帳號</label>
          <input
            id="username"
            name="username"
            type="text"
            autoComplete="username"
            placeholder="帳號"
            value={username}
            onChange={(e) => setUsername(e.target.value)}
          />
        </div>
        <div className="login-field">
          <label htmlFor="password">密碼</label>
          <input
            id="password"
            name="password"
            type="password"
            autoComplete="current-password"
            placeholder="密碼"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
          />
        </div>

        <button type="submit" className="login-button" disabled={isSubmitting}>
          {isSubmitting ? "登入中…" : "前往管理者頁面"}
        </button>
      </form>
    </div>
  );
}

function AppLayout() {
  // 用 sessionStorage 記住登入狀態，不然單純重新整理頁面就會被踢回登入頁
  // （分頁關閉後失效即可，管理後台不需要跨瀏覽器工作階段的長期登入）。
  const [isLoggedIn, setIsLoggedIn] = useState(
    () => sessionStorage.getItem("managerLoggedIn") === "true"
  );

  const handleLogin = () => {
    sessionStorage.setItem("managerLoggedIn", "true");
    setIsLoggedIn(true);
  };

  const handleLogout = () => {
    sessionStorage.removeItem("managerLoggedIn");
    setIsLoggedIn(false);
  };

  return (
    <main>
      <Routes>
        <Route
          path="/"
          element={<HomePage onLogin={handleLogin} />}
        />
        <Route
          path="/admin"
          element={
            isLoggedIn ? (
              <AdminPage
                isLoggedIn={isLoggedIn}
                onLogout={handleLogout}
              />
            ) : (
              <Navigate to="/" />
            )
          }
        />
        <Route
          path="/calendar/:username"
          element={
            isLoggedIn ? (
              <UserCalendarWrapper
                isLoggedIn={isLoggedIn}
                onLogout={handleLogout}
              />
            ) : (
              <Navigate to="/" />
            )
          }
        />
        <Route
          path="/playlist"
          element={
            isLoggedIn ? (
              <PlaylistPage
                isLoggedIn={isLoggedIn}
                onLogout={handleLogout}
              />
            ) : (
              <Navigate to="/" />
            )
          }
        />
        <Route
          path="/events"
          element={
            isLoggedIn ? (
              <EventFunnelPage
                isLoggedIn={isLoggedIn}
                onLogout={handleLogout}
              />
            ) : (
              <Navigate to="/" />
            )
          }
        />
      </Routes>
    </main>
  );
}

function App() {
  return (
    <Router>
      <AppLayout />
    </Router>
  );
}

export default App;
